import React from 'react';
import Lottie from 'react-lottie';
import './Message_Lottie.css';
import * as animationData from './Message_Lottie.json';

function Message_Lottie(props) {
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='success_div'>
                <div className='Message_Lottie_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}
                          
                    />
                </div>
                <p className='success_text'>{props?.successText}</p>
            </div>

        </section>
    );
}
export default Message_Lottie;